import { render, staticRenderFns } from "./AddBrokerAccount.vue?vue&type=template&id=48e9a242&scoped=true"
import script from "./AddBrokerAccount.vue?vue&type=script&lang=js"
export * from "./AddBrokerAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e9a242",
  null
  
)

export default component.exports